import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function LmsPaiement() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [status, setStatus] = useState("checking");
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const check = () => api.get(`/lms/pay/confirm?session_id=${sessionId}`).then(({ data }) => {
      if (data.status === "paid") setStatus("paid");
      else if (tries++ < 5) setTimeout(check, 2000);
      else setStatus("pending");
    }).catch(() => setStatus("error"));
    check();
  }, [sessionId]);

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-md flex-col items-center justify-center px-4 text-center" data-testid="lms-paiement-page">
      {status === "checking" && <><Loader2 className="animate-spin text-[#0E7C7B]" size={36} /><p className="mt-3 text-slate-500">Vérification du paiement…</p></>}
      {status === "paid" && <><CheckCircle2 className="text-emerald-500" size={44} /><h1 className="mt-3 font-display text-2xl font-bold text-navy">Paiement confirmé</h1><p className="mt-1 text-slate-500">Vous avez désormais accès à votre formation.</p><button onClick={() => nav("/cours")} className="mt-5 rounded-full bg-[#0E7C7B] px-6 py-2.5 text-sm font-semibold text-white">Voir mes cours</button></>}
      {(status === "pending" || status === "error") && <><XCircle className="text-amber-500" size={44} /><h1 className="mt-3 font-display text-2xl font-bold text-navy">Paiement en attente</h1><p className="mt-1 text-slate-500">Si vous avez été débité·e, l'accès sera activé sous peu.</p><button onClick={() => nav("/cours")} className="mt-5 rounded-full bg-navy px-6 py-2.5 text-sm font-semibold text-white">Retour aux formations</button></>}
    </div>
  );
}
